import SenseInsightsAnalyticsConnections from "../components/senseinsights-analytics_management/ConnectionStatusUI"

export const AnalyticsManagement = () => {
    return (
        <div>
            <SenseInsightsAnalyticsConnections />
        </div>
    )
}